import React from 'react';

const PostcodeStep = ({ value, onChange, error }) => {
  return (
    <div className="w-full">
      {/* Title */}
      <h2 className="mb-12 text-center text-[24px] font-bold text-black">
        Enter Your Postcode
      </h2>

      {/* Background Image with Overlay */}
      <div className="relative mx-auto max-w-[1240px] overflow-hidden rounded-lg">
        {/* Background Image */}
        <div className="h-[516px] w-full">
          <img
            src="https://foxwindowsanddoors.com/app/uploads/form/postcode.jpg"
            alt="Background"
            className="h-full w-full object-cover"
          />
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/50" />
          {/* Bottom gradient */}
          <div className="absolute inset-x-0 bottom-0 h-[281px] bg-gradient-to-b from-transparent to-black" />
        </div>

        {/* Form Card Overlay */}
        <div className="absolute left-1/2 top-1/2 w-full max-w-[631px] -translate-x-1/2 -translate-y-1/2 bg-gray-100 p-12">
          <p className="mx-auto mb-6 text-center text-[15px] leading-[20px] text-[#4c4c4c]">
            We need to check that we cover your area
          </p>

          {/* Postcode Input */}
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value.toUpperCase())}
            placeholder="Postcode"
            className="mb-6 w-full border border-[#d9d9d9] bg-white px-6 py-3 text-[15px] text-black placeholder:text-[#9ca2ae] focus:border-[#ED6B64] focus:outline-none"
          />

          {/* Error Message */}
          {error && (
            <p className="mb-4 text-center text-sm text-red-500">{error}</p>
          )}

          {/* Note: Next button is handled by parent form */}
        </div>
      </div>
    </div>
  );
};

export default PostcodeStep;
